import React from "react";
import { Navigate, Route } from "react-router-dom";
import {getToken} from "../utils/helpers/custom";

const AuthProtected = (props) => {
  const token = getToken();

  /*
    redirect is un-auth access protected routes via url
  */

  if (!token) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };